import dayjs, { ManipulateType } from "dayjs";

export const devConfig = {
  isProduction: false,
  alone: {
    allowAlone: process.env.NODE_ENV === "development",
    aloneTimeout: 60, // minutes to show alert if user is alone
    aloneSwitchTimeout: 60, // seconds to switch channel
  },
  serverUrl: "https://pastlv.com",
  cdnUrl: "https://pic.pastlv.com/",
  sentryUrl: "https://01ff19e66d6f40b19cea2cb64e92c5b5@o1268873.ingest.sentry.io/4504014342389760",
  landingUrl: "",
  allowTesters: true,
  fdRules: {
    allowFd: false,
    userCameraOffTimeout: process.env.NODE_ENV === "development" ? 120 : 10, // minutes to display an alert if camera off
    userMinutesAlert: 3, // minutes to display an alert
    userMinutesLeave: 0.5, // minutes to leave call after alert
    intervalSeconds: 10, // seconds to check if user is there
    isTimePassedIntervalSeconds: 1, // seconds to check if user is there
    allowBorderDebug: false, // process.env.NODE_ENV === "development";
  },
  audioDetection: {
    allowAudioDetection: false,
    userMinutesAlert: 1, // minutes to display an alert
    userMinutesLeave: 0.5, // minutes to leave call after alert
  },
  hideLogs: false,
  allowSpeechRecognition: false,
  allowAnalytics: false,
  analyticsDebug: true,
  showVoiceBorder: true,
  timeForConnection: 60 * 1000, // seconds to wait for connection to the channel
  showReactQueryDevtools: true,
  addToFriendTooltip: {
    delayMinutes: 1,
    friendsMinimalNumber: 2,
  },
  participantConnected: {
    allowHandle: process.env.NODE_ENV !== "development",
    soundUrl: "https://cdn.pastime.com/resources/sounds/ring.mp3",
    dialogTimer: 5, // seconds to show dialog
  },
  features: {
    clientSdkId: "628b24caafc6601519c2b210",
    flags: {
      hideBasicPageFg: false,
      hideGenderPageFg: false,
      hideStatePageFg: false,
      hideEducationPageFg: false,
    } as { [key: string]: boolean | number },
  },
  availableTime: {
    from: dayjs().hour(0).minute(0).millisecond(0),
    to: dayjs()
      .date(dayjs().date() + 1)
      .hour(0)
      .minute(0)
      .millisecond(0),
    step: {
      value: 1,
      unit: "hour" as ManipulateType,
    },
  },
  badNetworkQualityLevel: 3,
  badNetworkQualityTimeout: 20, // seconds to set high quality stream
  autoStarUsersTimeout: 0.5, // minutes to auto star users
  checkInternetConnection: true,
  networkQualityBanner: true,
  allowPermissionDialog: false,
  allowWelcomeRoomDialog: false,
  getChannelDelay: 1, // seconds to wait before getting channel
  newVersionDialogTimeout: 1, // minutes to show new version dialog
};
